import { useState, useEffect, Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import { Grid, FormGroup, DialogActions, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import axios from "axios";
import { saveItineraryList } from "../../../../store/actions";

//import constants
import BASE_URL from "../../../../constants/baseUrls";
import { IS_MOBILE } from "../../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../../../components/common/base-button/base-button";
import Loading from "../../../../components/common/loading/loading";
import BaseDialog from "../../../common/base-dialog/base-dialog";
import BaseCheckbox from "../../../common/base-checkbox/base-checkbox";

//import view components
import ReplaceItem from "../replace-item/replace-item";
import Category from "../mobile-view/category";

//import images and icons
import { ArrangeHorizontal, ArrowDown2, HambergerMenu, InfoCircle } from "iconsax-react";

//import styles
import "./replace.scss";
import EmptyOrErrorState from "../../../common/empty-or-error-state/empty-or-error-state";
import { toast } from "react-toastify";

function Replace({ dispatch, open, setOpen, list, loadingReplaceList, locationName, locationImage }) {
    //general variables
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    //set replace list
    const [replaceList, setReplaceList] = useState([]);
    const [originReplaceList, setOriginReplaceList] = useState([]);
    useEffect(() => {
        if (list) {
            setReplaceList(list);
            setOriginReplaceList(list);
        }
    }, [list]);

    //set value radio button
    const [selectedItem, setSelectedItem] = useState(null);
    const [checkedFreeTime, setCheckedFreeTime] = useState(null);
    //desktop
    const handleRadioChange = (event, type) => {
        setSelectedItem(event.target.value);
        if (type === "freeTime") {
            setCheckedFreeTime(event.target.checked);
        }
    };

    //free time
    const [freeTime, setFreeTime] = useState(false);
    const [freeTimeGlobalId, setFreeTimeGlobalId] = useState();
    useEffect(() => {
        if (originReplaceList?.length) {
            const freeItem = replaceList?.find(replaceItem => replaceItem.ID === 0);
            setFreeTime(!!freeItem ? true : false);
            setFreeTimeGlobalId(!!freeItem ? freeItem.global_id : "");
        }
    }, [originReplaceList]);

    //close modal
    const handleClose = async () => {
        setState(values => {
            Object.keys(values).forEach(item => {
                values[item] = false;
            });
            return values;
        });
        setFilters([]);
        setFreeTime(false);
        setCheckedFreeTime(false);
        setSelectedItem("");
        setReplaceList([]);
        setOpen(false);
        searchParams.delete("action");
        setSearchParams(searchParams, { replace: true });
    };

    //set value check box for category
    const [state, setState] = useState({
        Adventure: false,
        Nature: false,
        Religious: false,
        Historical: false,
        Art_Cultural: false,
        Shopping: false,
        Restaurant: false,
    });

    //filter replace list
    const [filters, setFilters] = useState([]);
    const handleChangeCheckBox = event => {
        resetFilteredList();
        const filterName = event.target.name;
        // const filterName = name.substr(0, 1).toUpperCase() + name.substr(1);
        setState({
            ...state,
            [event.target.name]: event.target.checked,
        });
        if (!(filters.indexOf(filterName) > -1)) {
            setFilters(oldValues => [...oldValues, filterName]);
        } else {
            const filtersCopy = [...filters];
            filtersCopy.splice(filters.indexOf(filterName), 1);
            setFilters(filtersCopy);
        }
    };

    useEffect(() => {
        let filteredList = [];
        if (filters.length) {
            filteredList = originReplaceList.filter(replaceItem => {
                if (filters.indexOf(replaceItem.category) > -1) {
                    return replaceItem;
                }
            });
        }
        filters.length ? setReplaceList(filteredList) : setReplaceList(originReplaceList);
    }, [filters]);

    const resetFilteredList = () => {
        setReplaceList(originReplaceList);
    };
    const { Adventure, Nature, Religious, Historical, Art_Cultural, Shopping, Restaurant } = state;

    //filter replace list
    const replaceFilterList = [
        { id: 1, label: t("adventure"), name: "Adventure", checked: Adventure },
        { id: 2, label: t("nature"), name: "Nature", checked: Nature },
        { id: 3, label: t("religious"), name: "Religious", checked: Religious },
        { id: 4, label: t("historical"), name: "Historical", checked: Historical },
        { id: 5, label: t("artCultural"), name: "Art_Cultural", checked: Art_Cultural },
        { id: 6, label: t("shopping"), name: "Shopping", checked: Shopping },
        { id: 7, label: t("restaurant"), name: "Restaurant", checked: Restaurant },
    ];

    //handle filter modal for mobile size
    const [openCategory, setOpenCategory] = useState(false);

    //replace itinerary request
    const [loadingItinerary, setLoadingItinerary] = useState(false);
    const submitReplaceItinirary = async event => {
        event.preventDefault();
        try {
            setLoadingItinerary(true);
            const params = JSON.stringify({
                to_global_id: selectedItem,
            });
            const response = await axios.post(`${BASE_URL}/itinerary/get_new_plan/`, params, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            dispatch(saveItineraryList(response.data));
        } catch (error) {
            toast.error(t("errorMessage"));
        } finally {
            handleClose();
            setLoadingItinerary(false);
        }
    };

    return (
        <BaseDialog title={t("alternativeTitle")} open={open} handleClose={handleClose} maxWidth="lg" top="0" icon="close">
            <form
                onSubmit={event => {
                    submitReplaceItinirary(event);
                    handleClose();
                }}
            >
                <DialogContent dividers={true}>
                    <Grid container item xs={12} rowGap={2} justifyContent="center">
                        <Grid className="replace__location-header" container item xs={12} columnGap={1} alignItems="center">
                            <img src={"https://api.atripa.com" + locationImage} />

                            <Grid container item xs="auto" direction="column">
                                <span className="replace__previous-name">{locationName}</span>
                                <span className="replace__text">{t("replacedWith")}:</span>
                            </Grid>
                        </Grid>

                        <Grid container item xs={12} rowGap={2} justifyContent="space-between" alignItems="flex-start" mt={5}>
                            <Grid className="replace__description" container item xs={12} display={{ xs: "flex", md: "none" }}>
                                <p>{t("itineraryMessage4")}</p>
                            </Grid>
                            {freeTime && (
                                <Grid
                                    className="replace__free-time"
                                    container
                                    item
                                    xs={5.8}
                                    md={1.5}
                                    display={{ xs: "flex", md: "none" }}
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <BaseButton
                                        text={t("replaceFreeTime")}
                                        color="secondary"
                                        size="medium"
                                        radius="radius-10"
                                        rightIcon={<ArrangeHorizontal size="20" color="var(--light-color)" variant="Outline" />}
                                        type="submit"
                                        handleClick={() => setSelectedItem(freeTimeGlobalId)}
                                    />
                                </Grid>
                            )}

                            <Grid className="replace__category-list" container item xs={5.8} md={3} alignItems="flex-end">
                                <Grid
                                    className="replace__category"
                                    container
                                    item
                                    xs={12}
                                    columnGap={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    onClick={IS_MOBILE ? () => setOpenCategory(true) : undefined}
                                >
                                    <HambergerMenu size="18" color="var(--secondary-color)" />
                                    <span>{t("category")}</span>
                                    {filters.length > 0 && (
                                        <span>
                                            ({filters.length} {t("filter")})
                                        </span>
                                    )}
                                </Grid>

                                <Category
                                    open={openCategory}
                                    setOpen={setOpenCategory}
                                    replaceList={replaceList}
                                    replaceFilterList={replaceFilterList}
                                    handleChangeCheckBox={handleChangeCheckBox}
                                />

                                <Grid className="replace__filter" item xs={12} display={{ xs: "none", md: "flex" }}>
                                    <Grid
                                        className="replace__title-filter"
                                        container
                                        item
                                        xs={12}
                                        display={{ xs: "flex", md: "none" }}
                                        justifyContent="space-between"
                                    >
                                        <ArrowDown2 size="24" color="var(--light-color)" onClick={() => setOpenCategory(false)} />
                                        <span>{t("category")}</span>
                                        <ArrowDown2 color="var(--primary-color)" />
                                    </Grid>
                                    <FormGroup>
                                        {replaceFilterList.map(filter => {
                                            return (
                                                <BaseCheckbox
                                                    key={filter?.id}
                                                    label={filter?.label}
                                                    name={filter?.name}
                                                    checked={filter?.checked}
                                                    handleChange={handleChangeCheckBox}
                                                    disabled={
                                                        !list?.length ||
                                                        (replaceList?.length === 1 && replaceList.find(item => item.category === "free")) ||
                                                        checkedFreeTime
                                                    }
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </Grid>
                            </Grid>

                            <Grid
                                className={`replace__replace-list ${checkedFreeTime ? "disabled" : ""}`}
                                container
                                item
                                xs={12}
                                md={8.5}
                                rowGap={2}
                                justifyContent="center"
                            >
                                {loadingReplaceList || loadingItinerary ? (
                                    <Loading />
                                ) : replaceList?.length && replaceList?.find(item => item.category !== "free") ? (
                                    replaceList.map(replaceItem => {
                                        return (
                                            <Fragment key={replaceItem?.ID}>
                                                {replaceItem.category === "free" && replaceItem.ID === 0 ? null : (
                                                    <ReplaceItem
                                                        replaceItem={replaceItem}
                                                        selectedItem={selectedItem}
                                                        handleRadioChange={handleRadioChange}
                                                        handleReplaceItem={setSelectedItem}
                                                        checkedFreeTime={checkedFreeTime}
                                                    />
                                                )}
                                            </Fragment>
                                        );
                                    })
                                ) : (replaceList?.length === 1 && replaceList.find(item => item.category === "free")) || !replaceList?.length ? (
                                    <EmptyOrErrorState
                                        title={t("replacementPlanMessage")}
                                        icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container item xs={11.5} justifyContent="flex-end" columnGap={1}>
                        {freeTime && (
                            <Grid
                                className="replace__free-time"
                                container
                                item
                                xs={5}
                                md={1.5}
                                display={{ xs: "none", md: "flex" }}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <input
                                    id="free"
                                    type="checkbox"
                                    name="freeTime"
                                    value={freeTimeGlobalId}
                                    onChange={e => handleRadioChange(e, "freeTime")}
                                ></input>
                                <label htmlFor="free">{t("freeTime")}</label>
                            </Grid>
                        )}
                        <Grid className="suggestions__replace" container item xs={12} md={2} display={{ xs: "none", md: "flex" }} alignItems="center">
                            <BaseButton
                                text={t("replace")}
                                color="primary"
                                size="large"
                                radius="radius-10"
                                handleClick={event => {
                                    submitReplaceItinirary(event);
                                    handleClose();
                                }}
                                disabled={selectedItem ? false : true}
                            />
                        </Grid>
                    </Grid>
                </DialogActions>
            </form>
        </BaseDialog>
    );
}

export default connect()(Replace);
